import { TextStyle } from '@client/style/TextStyles';
import React, { forwardRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import Site from '@client/store/Site';
import PreloaderStore from '../Preloader/PreloaderStore';
import WaltherLogo from '@client/assets/svgs/waltherlogo.svg';
import Link from '@client/core/PageSwitch/Link';
import { Colors, Index } from '@client/style/Variables';

const Container = styled(Link)<{ $color?: string }>`
	z-index: ${Index.FullScreenMenu - 1};
	display: flex;
	position: relative;
	color: ${props => props.color ?? Colors.defaultWhite};
`;

const TextContainer = styled.div`
	margin-left: 10px;
	margin-top: 3px;
`;

const StyledWalther = styled(WaltherLogo)`
	height: 42px;
	width: 43px;
	fill: currentColor;
`;

const Title = styled.div`
	${TextStyle.size('large')}
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
`;

const DateContainer = styled.div`
	${TextStyle.size('medium')}
	${TextStyle.family('title')}
	${TextStyle.weight('regular')}
	margin-top: -3px;
	letter-spacing: -0.6px;
`;

const LogoWithText = forwardRef<HTMLAnchorElement, { color?: string; className?: string; onClick?: () => void }>(
	function LogoWithText({ className, color, onClick }, ref) {
		const topMenuInformation = Site.use(state => state.global);
		const loadedItems = PreloaderStore.use(state => state.loadedItems);
		const itemsToLoad = PreloaderStore.use(state => state.itemsToLoad);
		const [animReady, setAnimReady] = useState(false);

		useEffect(() => {
			if (loadedItems === itemsToLoad) setAnimReady(true);
		}, [loadedItems]);

		return (
			<Container $color={color} className={className} data={{ link: '/' }} onClick={onClick} ref={ref}>
				{animReady && (
					<>
						{/* <ObjectSlideInAnimation direction='fromLeft' duration={1.5} onCompleteExecution={stopWaltherWalking}> */}
						<StyledWalther />
						{/* </ObjectSlideInAnimation> */}

						<TextContainer>
							<Title>
								{/* <TextSlideInAnimation text={topMenuInformation.topMenuTitle} delay={0.3} breakAtWord={true} /> */}
								{topMenuInformation.topMenuTitle}
							</Title>

							<DateContainer>
								{/* <TextSlideInAnimation
								text={topMenuInformation.topMenuDato}
								breakAtWord={true}
								direction='fromLeft'
								delay={0.6}
								/> */}
								{topMenuInformation.topMenuDato}
							</DateContainer>
						</TextContainer>
					</>
				)}
			</Container>
		);
	}
);

export default LogoWithText;
